import { useMemo } from 'react';
import type { Dictionary, DocumentId } from '../types';
import type { ListToTree } from '../utils';

export const useTreeData = <
  TList extends Dictionary<unknown>,
  TKey extends string,
  TNode extends { [x in TKey]?: TNode[] },
>(
  rootId: DocumentId | undefined,
  list: TList,
  listToTree: ListToTree<TList, TKey, TNode>,
  isReady: boolean,
) => {
  return useMemo(() => {
    if (!isReady || !rootId) {
      return;
    }

    return listToTree([rootId], list);
  }, [rootId, list, listToTree, isReady]);
};
